<template>
	<div class="login-container">
		<el-row>
			<el-col :lg="14" :md="11" :sm="24" :xl="14" :xs="24">
				<div class="left-container">
					<div class="tech-elements">
						<div class="tech-title">智慧停车解决方案</div>
						<div class="tech-subtitle">科技赋能停车管理 · 提升空间利用率</div>
						<div class="tech-features">
							<div class="feature-item">
								<el-icon>
									<Place/>
								</el-icon>
								<span>空余车位智能引导</span>
							</div>
							<div class="feature-item">
								<el-icon>
									<Timer/>
								</el-icon>
								<span>实时车位监控与管理</span>
							</div>
							<div class="feature-item">
								<el-icon>
									<Money/>
								</el-icon>
								<span>便捷支付与结算</span>
							</div>
							<div class="feature-item">
								<el-icon>
									<DataAnalysis/>
								</el-icon>
								<span>数据分析与决策</span>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg="9" :md="12" :sm="24" :xl="9" :xs="24">
				<el-form
						ref="form"
						:model="form"
						:rules="rules"
						class="login-form"
						label-position="left"
				>
					<div class="title">欢迎使用</div>
					<div class="title-tips">{{ Company.title }}智慧停车系统</div>
					<div class="login-form-sub-title">请使用微信扫码登录</div>
					<el-row class="qrcode-container">
						<el-image
								:src="'data:image/png;base64,' + loginImage"
								style="width: 180px; margin-top: 20px"
						/>
						<div class="refresh-btn" @click="getCode">
							<i class="el-icon-refresh"></i>
							<span>刷新二维码</span>
						</div>
					</el-row>
				</el-form>
			</el-col>
			<el-col :lg="1" :md="1" :sm="24" :xl="1" :xs="24">
				<div style="color: transparent">占位符</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import {login} from "../../network/api/index";
import Company from "../../config";
import {createLoginQrCode, loginByQrCode} from "../../network/api/index";
import qrcodeIconImg from '@/assets/image/qrcode-icon.jpg';
import {urlToBase64} from "@/utils/index";
// import { Refresh } from "@element-plus/icons";

var Timer = null;
var TimerNum = 0;

export default {
	name: "Login",
	// components: { Refresh },
	directives: {
		focus: {
			inserted(el) {
				el.querySelector("input").focus();
			},
		},
	},
	created() {
		this.getCode();
	},
	beforeRouteLeave(to, from, next) {
		clearInterval(this.timer);
		next();
	},
	data() {
		const validateUsername = (rule, value, callback) => {
			if ("" === value) callback(new Error("用户名不能为空"));
			else callback();
		};
		const validatePassword = (rule, value, callback) => {
			if ("" === value) callback(new Error("请输入密码"));
			else callback();
		};
		return {
			nodeEnv: process.env.NODE_ENV,
			Company: Company,
			form: {
				username: "",
				password: "",
			},
			rules: {
				username: [
					{
						required: true,
						trigger: "blur",
						validator: validateUsername,
					},
				],
				password: [
					{
						required: true,
						trigger: "blur",
						validator: validatePassword,
					},
				],
			},
			loading: false,
			passwordType: "password",
			redirect: undefined,
			timer: 0,

			loginImage: "",
		};
	},

	watch: {
		$route: {
			handler(route) {
				this.redirect = (route.query && route.query.redirect) || "/";
			},
			immediate: true,
		},
	},
	methods: {
		handlePassword() {
			this.passwordType === "password"
					? (this.passwordType = "")
					: (this.passwordType = "password");
			this.$nextTick(() => {
				this.$refs.password.focus();
			});
		},
		async getCode() {

			let base64 = urlToBase64(qrcodeIconImg);
			base64.then(async (resolve) => {
				const {data, code} = await createLoginQrCode({
					width: "400",
					height: "400",
					contentType: 1,
					doMainId: Company.doMainId,
					logoText: Company.logoText,
					logoIconBase64: resolve.substr(resolve.indexOf(',') + 1)
				});
				if (code === 10002) {
					this.loginImage = data.qr_code_images;
					Timer = setInterval(() => {
						this.checkCodeStatus(data.qr_code.id, data.qr_code.randomCode);
						TimerNum += 1;
						if (TimerNum >= 490) {
							clearInterval(Timer);
							TimerNum = 0;
							this.loginImage = "";
							this.$notify.error({
								title: "提示",
								message: "码已失效 请手动刷新",
							});
							// getCode()
						}
					}, 1000);
				}
			})

		},
		async checkCodeStatus(id, randomCode) {
			const {data, code, token} = await loginByQrCode({
				qrCodeId: id,
				randomCode: randomCode,
			});
			if (code == 10002) {
				clearInterval(Timer);
				TimerNum = 0;
				localStorage.setItem("userInfo", JSON.stringify(data));
				localStorage.setItem("token", token.access_token);
				this.$router.push("/");
				this.$notify({
					title: "提示",
					message: "登录成功",
					type: "success",
				});
			} else {
				if (code !== 28002) {
					clearInterval(Timer);
					TimerNum = 0;
					this.loginImage = "";
				}
			}
		},
		handleRoute() {
			return this.redirect === "/404" || this.redirect === "/403"
					? "/"
					: this.redirect;
		},
		handleLogin() {
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					try {
						this.loading = true;
						var {data, token, code, message} = await login(this.form);
						if (code == 10002) {
							this.$notify({
								title: "提示",
								message: "登录成功",
								type: "success",
							});
							localStorage.setItem("userInfo", JSON.stringify(data));
							localStorage.setItem("token", token.jwt_token);
							this.$router.push("/");
						} else {
							this.$notify.error({
								title: "提示",
								message: message,
							});
						}
					} finally {
						this.loading = false;
					}
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style scoped>
.login-container {
	height: 100vh;
	background: url("../../assets/login_images/background.jpg") center center fixed no-repeat;
	background-size: cover;
	position: relative;
}

.login-container::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 1;
}

.left-container {
	position: relative;
	z-index: 2;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-left: 8vw;
}

.tech-elements {
	max-width: 80%;
}

.tech-title {
	font-size: 3.5rem;
	font-weight: 700;
	color: #fff;
	margin-bottom: 20px;
	text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.tech-subtitle {
	font-size: 1.5rem;
	color: #e6e6e6;
	margin-bottom: 60px;
}

.tech-features {
	display: flex;
	flex-wrap: wrap;
	gap: 30px;
}

.feature-item {
	display: flex;
	align-items: center;
	background: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(5px);
	padding: 15px 20px;
	border-radius: 8px;
	width: calc(50% - 15px);
	transition: all 0.3s ease;
}

.feature-item:hover {
	background: rgba(255, 255, 255, 0.2);
	transform: translateY(-5px);
}

.feature-item i {
	font-size: 24px;
	margin-right: 10px;
	color: #62d2a2;
}

.feature-item span {
	color: #fff;
	font-size: 16px;
}

.login-form {
	position: relative;
	z-index: 2;
	max-width: 100%;
	padding: 4.5vh;
	margin: calc((100vh - 475px) / 2) 5vw 5vw;
	overflow: hidden;
	background: rgba(34, 34, 34, 0.8);
	backdrop-filter: blur(10px);
	border-radius: 12px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.login-form .title {
	font-size: 42px;
	font-weight: 600;
	color: #fff;
	text-align: center;
}

.login-form .title-tips {
	margin-top: 15px;
	font-size: 22px;
	font-weight: 400;
	color: #fff;
	text-align: center;
}

.login-form .login-form-sub-title {
	margin-top: 15px;
	font-size: 16px;
	color: #aaa;
	text-align: center;
}

.qrcode-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 30px;
}

.refresh-btn {
	margin-top: 20px;
	color: #62d2a2;
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: all 0.3s;
}

.refresh-btn:hover {
	color: #7fe9b6;
}

.refresh-btn i {
	margin-right: 5px;
}

.login-form ::v-deep .el-form-item {
	padding-right: 0;
	margin: 20px 0;
	color: #454545;
	background: transparent;
	border: 1px solid transparent;
	border-radius: 2px;
}

.login-form ::v-deep .el-form-item__content {
	min-height: 32px;
	line-height: 32px;
}

.login-form ::v-deep .el-form-item__error {
	position: absolute;
	top: 100%;
	left: 18px;
	font-size: 12px;
	line-height: 18px;
	color: #ff4d4f;
}

.login-form ::v-deep .el-input {
	box-sizing: border-box;
}

.login-form ::v-deep .el-input input {
	height: 48px;
	padding-left: 35px;
	font-size: 14px;
	line-height: 58px;
	background: #f6f4fc;
	border: 0;
}

@media (max-width: 768px) {
	.left-container {
		display: none;
	}

	.login-form {
		margin: 20vh auto 0;
		max-width: 90%;
	}
}
</style>
